// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
//引入全局css
import "./assets/styles/reset.css";
import "./assets/styles/index.css";

//自定义指令
import "./directives/ellipsis";

//element ui
import { Message, MessageBox } from "element-ui";

import VueI18n from "vue-i18n";

const x = new Vue();

Vue.use(VueI18n);
Vue.prototype.$bus = x;

function getBrowserLang() {
    let lang = navigator.language || navigator.userLanguage;
    if (lang !== "en_US" && lang !== "zh_CN") {
        lang = "zh_CN";
    }
    return lang;
}
const lang = localStorage.getItem("lang")
    ? localStorage.getItem("lang")
    : getBrowserLang();
const i18n = new VueI18n({
    locale: lang,
    messages: {
        zh_CN: require("./assets/lang/zh"),
        en_US: require("./assets/lang/en"),
    },
});

const getTitle = () => {
    const title = document.createElement("title");
    title.textContent =
        !localStorage.getItem("lang") ||
        localStorage.getItem("lang") === "zh_CN"
            ? /oceanbluecloud\.tech/g.test(window.location.host)
                ? "睿网云联"
                : "睿云网络"
            : "OceanBlue Cloud";
    document.getElementsByTagName("head")[0].appendChild(title);
};
getTitle();

// Vue.prototype.$ELEMENT = { size: "small", zIndex: 99999999999999999 };
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.config.productionTip = false;

new Vue({
    el: "#app",
    i18n,
    router,
    components: { App },
    template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js